// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {MeasurementUnit} from './measurement-unit.js'

export class MeasurementScale {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): MeasurementScale {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  scaleFactor(): number {
    return this.bb!.readFloat32(this.bb_pos)
  }

  unit(): MeasurementUnit {
    return this.bb!.readInt8(this.bb_pos + 4)
  }

  static sizeOf(): number {
    return 8
  }

  static createMeasurementScale(
    builder: flatbuffers.Builder,
    scale_factor: number,
    unit: MeasurementUnit
  ): flatbuffers.Offset {
    builder.prep(4, 8)
    builder.pad(3)
    builder.writeInt8(unit)
    builder.writeFloat32(scale_factor)
    return builder.offset()
  }
}
